/**
 * Collection product card badges: JSON from [data-product-card-badges-config],
 * renders into [data-product-card-badges-list], updates on swatch change.
 * First paint: Liquid may SSR the initial pill (data-badge-ssr); first refreshRoot skips DOM replace.
 *
 * At most one badge is shown. First match wins (Liquid still sends all flags per color):
 *   1. preorder  2. limitedStock  3. sellingFast  4. limitedEdition  5. new  6. twoLengths
 *
 * Extend: add keys in Liquid (badge.liquid) + PRIORITY below + label data attributes.
 */
(function () {
  'use strict';

  var PRIORITY = ['preorder', 'limitedStock', 'sellingFast', 'limitedEdition', 'new', 'twoLengths'];

  function labelsFromRoot(root) {
    return {
      preorder: root.getAttribute('data-l-po') || 'Preorder',
      limitedStock: root.getAttribute('data-l-ls') || 'Limited Stock',
      sellingFast: root.getAttribute('data-l-sf') || 'Selling Fast',
      twoLengths: root.getAttribute('data-l-tl') || '2 Lengths',
      limitedEdition: root.getAttribute('data-l-le') || 'Limited Edition',
      new: root.getAttribute('data-l-nw') || 'New',
    };
  }

  function getConfig(root) {
    var el = root.querySelector('[data-product-card-badges-config]');
    if (!el || !el.textContent) return null;
    try {
      return JSON.parse(el.textContent.trim());
    } catch (e) {
      return null;
    }
  }

  function pickRow(config, colorKey) {
    if (!config || typeof config !== 'object') return null;
    if (colorKey && config[colorKey]) return config[colorKey];
    if (config._single) return config._single;
    var keys = Object.keys(config);
    if (keys.length === 1) return config[keys[0]];
    if (!colorKey && keys.length > 0) return config[keys[0]];
    return null;
  }

  function renderBadgePills(listEl, row, labels) {
    if (!listEl) return;
    listEl.innerHTML = '';
    if (!row) return;

    for (var i = 0; i < PRIORITY.length; i++) {
      var key = PRIORITY[i];
      if (!row[key]) continue;
      var li = document.createElement('li');
      li.className =
        'product-card-badges__item product-card-badges__item--' +
        key.replace(/([A-Z])/g, '-$1').toLowerCase();
      li.setAttribute('role', 'listitem');
      var span = document.createElement('span');
      span.className = 'product-card-badges__pill';
      span.textContent = labels[key] || key;
      li.appendChild(span);
      listEl.appendChild(li);
      return;
    }
  }

  function render(listEl, config, colorKey, root) {
    var badgeRoot =
      root ||
      (listEl && listEl.closest ? listEl.closest('[data-product-card-badges]') : null);
    var labels = badgeRoot
      ? labelsFromRoot(badgeRoot)
      : {
          preorder: 'Preorder',
          limitedStock: 'Limited Stock',
          sellingFast: 'Selling Fast',
          twoLengths: '2 Lengths',
          limitedEdition: 'Limited Edition',
          new: 'New',
        };
    var row = pickRow(config, colorKey);
    renderBadgePills(listEl, row, labels);
  }

  function refreshRoot(root) {
    if (root.getAttribute('data-badge-ssr') === '1') {
      root.removeAttribute('data-badge-ssr');
      return;
    }
    var list = root.querySelector('[data-product-card-badges-list]');
    var cfg = getConfig(root);
    var initial = root.getAttribute('data-initial-color') || '';
    var color = initial;
    if (cfg && !pickRow(cfg, color)) {
      var keys = Object.keys(cfg).filter(function (k) {
        return k !== '_single';
      });
      if (keys.length) color = keys[0];
    }
    render(list, cfg, color, root);
  }

  function refreshFromSwatch(swatchEl) {
    if (!swatchEl) return;
    var color = swatchEl.getAttribute('data-color');
    if (!color) return;
    var card = swatchEl.closest('.card-wrapper') || swatchEl.closest('.card');
    if (!card) return;
    var root = card.querySelector('[data-product-card-badges]');
    if (!root) return;
    var list = root.querySelector('[data-product-card-badges-list]');
    var cfg = getConfig(root);
    root.setAttribute('data-initial-color', color);
    render(list, cfg, color, root);
  }

  function initAll() {
    document.querySelectorAll('[data-product-card-badges]').forEach(function (root) {
      refreshRoot(root);
    });
  }

  window.ProductCardBadges = {
    render: render,
    refreshFromSwatch: refreshFromSwatch,
    refreshRoot: refreshRoot,
    initAll: initAll,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('section:load', initAll);
})();
